import { Button, ButtonProps } from '@design-system/button';
import { LinkProps } from '@design-system/link';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import TMPLinkWrap from '~/components/TMPLinkWrap';

import { LinksListProps } from './models';

const LinksList = forwardRef<HTMLDivElement, LinksListProps>(
  ({ pageBlockUI, componentId, items }, ref) => (
    <PageBlock
      {...pageBlockUI}
      id={componentId}
      className="gth-links-list"
      ref={ref}
    >
      <ul className="gth-links-list__list">
        {items.map(({ isButton, ...itemProps }, index) => {
          const key = `${isButton ? 'button' : 'link'}_${index}`;
          if (isButton)
            return (
              <li key={key} className="gth-links-list__item">
                <Button {...(itemProps as ButtonProps)} />
              </li>
            );

          return (
            <li key={key} className="gth-links-list__item">
              <TMPLinkWrap {...(itemProps as LinkProps)} />
            </li>
          );
        })}
      </ul>
    </PageBlock>
  )
);

export default LinksList;
